<template>
     <!-- Topbar -->
    <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

        <!-- Sidebar Toggle (Topbar) -->
        
        <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
        <i class="fa fa-bars"></i>
        </button>
        
        <ul class="navbar-nav ml-auto">

            <!-- Nav Item - Search Dropdown (Visible Only XS) -->
            <li class="nav-item dropdown no-arrow d-sm-none">
            <a class="nav-link dropdown-toggle" href="#" id="searchDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-search fa-fw"></i>
            </a>
            <!-- Dropdown - Messages -->
            <div class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in" aria-labelledby="searchDropdown">
                <form class="form-inline mr-auto w-100 navbar-search">
                <div class="input-group">
                    <input type="text" class="form-control bg-light border-0 small" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2">
                    <div class="input-group-append">
                    <button class="btn btn-primary" type="button">
                        <i class="fas fa-search fa-sm"></i>
                    </button>
                    </div>
                </div>
                </form>
            </div>
            </li>
            <div class="topbar-divider d-none d-sm-block"></div>

            <!-- Nav Item - User Information -->
            <li class="nav-item dropdown no-arrow">
            <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="mr-2 d-none d-lg-inline text-gray-600 small">Hello, {{name}}</span>
            </a>
            <!-- Dropdown - User Information -->
            <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                <a class="dropdown-item" href="#" data-toggle="modal" @click="Logout()">
                <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                登出
                </a>
            </div>
            </li>

        
        </ul>

        <div style="position:fixed;right:10px;top:75px;z-index:1px;display:none;">
            <div class="alert alert-success" role="alert" >
                This is a success alert—check it out!
            </div>   
            <div class="alert alert-success" role="alert" >
                This is a success alert—check it out!2
            </div>   
        </div>
       
        
  

    </nav>
    <!-- End of Topbar -->
</template>
<script src="../../../static/vendor/bootstrap/js/bootstrap.bundle.min.js" ></script>
<script>
import {fb, db } from '../../firebase'
export default {
    name: 'Topbar',
    data () {
        return {
            name:''
        }
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    },
    mounted() {
        
        var head  = document.getElementsByTagName('head')[0];
        var link  = document.createElement('link');
        link.rel  = 'stylesheet';
        link.type = 'text/css';
        link.href = './static/css/sb-admin-2.css';
        head.appendChild(link);
        
        var login = localStorage.getItem("login");

        if ( login == null && this.currentRouteName != 'Login')  {
            this.$router.push({name: 'Login'});
        } else {
            this.GetName();
        }
     
    },
    methods: {
        GetName() {
            this.id = localStorage.getItem("user_id");
           
            db.collection("admin").doc(this.id).get().then((doc) => {
                if (doc.exists) {
                this.name = doc.data().name;;
                } else {
                localStorage.clear();
                this.$router.push({path: '/login'});
                }
            }).catch((error) => {
                localStorage.clear();
                this.$router.push({path: '/login'});
                console.log("Error getting document:", error);
            });
          
        },
        Logout(){
            if  ( confirm("是否確定登出")) {
                localStorage.clear();
                this.$router.push({name: 'Login'});
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/Topbar.vue